export const sectionSpacing = {
	xs: "80px",
	sm: "120px",
} as const;
